/* Slovenščina je izvorni jezik: ključ = besedilo. Tu so samo izjeme. */
export const sl = {};
